import * as React from 'react';

interface LocationHeaderProps {
  className?: string;
  title: string;
}

export const LocationHeader: React.FunctionComponent<LocationHeaderProps> = ({ className, title }) => (
  <div className={`uitk-cell ${className}`}>{title && <h3 className="uitk-type-heading-600 uitk-type-bold">{title}</h3>}</div>
);

LocationHeader.displayName = 'PropertyLocationHeader';
